module.exports = __webpack_public_path__ + "img/interface-screen-2.ead98f2.jpg";